import {BranchPickerInternal, type BranchPickerInternalProps} from './BranchPicker'

export function BranchPickerRelay(props: BranchPickerInternalProps) {
  return <BranchPickerInternal {...props} />
}

try{ BranchPickerRelay.displayName ||= 'BranchPickerRelay' } catch {}